"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DereferenceRdfCachePolicyDereferenceWrapper = void 0;
class DereferenceRdfCachePolicyDereferenceWrapper {
    cachePolicy;
    mediaTypes;
    constructor(cachePolicy, mediaTypes) {
        this.cachePolicy = cachePolicy;
        this.mediaTypes = mediaTypes;
    }
    storable() {
        return this.cachePolicy.storable();
    }
    async satisfiesWithoutRevalidation(action) {
        return this.cachePolicy.satisfiesWithoutRevalidation({ ...action, mediaTypes: this.mediaTypes });
    }
    responseHeaders() {
        return this.cachePolicy.responseHeaders();
    }
    timeToLive() {
        return this.cachePolicy.timeToLive();
    }
    async revalidationHeaders(newAction) {
        return this.cachePolicy.revalidationHeaders({ ...newAction, mediaTypes: this.mediaTypes });
    }
    async revalidatedPolicy(revalidationAction, revalidationResponse) {
        return await this.cachePolicy.revalidatedPolicy({ ...revalidationAction, mediaTypes: this.mediaTypes }, revalidationResponse);
    }
}
exports.DereferenceRdfCachePolicyDereferenceWrapper = DereferenceRdfCachePolicyDereferenceWrapper;
//# sourceMappingURL=DereferenceRdfCachePolicyDereferenceWrapper.js.map